import { z } from 'zod';

export const AccessPointTypeEnum = z.enum([
  'PARKING_GATE',
  'GARAGE_DOOR',
  'MAN_DOOR',
  'SECURITY_GRILLE',
]);
export type AccessPointTypeEnum = z.infer<typeof AccessPointTypeEnum>;

export const AccessPointRoleEnum = z.enum([
  'ENTRY',
  'EXIT',
  'BIDIRECTIONAL',
  'PEDESTRIAN_ENTRY',
  'PEDESTRIAN_EXIT',
  'PEDESTRIAN_BIDIRECTIONAL',
]);
export type AccessPointRoleEnum = z.infer<typeof AccessPointRoleEnum>;

export const AccessPoint = z.object({
  id: z.string(),
  name: z.string(),
  type: AccessPointTypeEnum,
  role: AccessPointRoleEnum.nullable().optional(),
  latitude: z.number(),
  longitude: z.number(),
  location_id: z.string(),
  device_id: z.string().nullable().optional(),
  camera_id: z.string().nullable().optional(),
  location_name: z.string().nullable().optional(),
  device_name: z.string().nullable().optional(),
  device_status: z.string().nullable().optional(),
  camera_name: z.string().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type AccessPointType = z.infer<typeof AccessPoint>;
export const AccessPointList = z.array(AccessPoint);
export type AccessPointListType = z.infer<typeof AccessPointList>;

export const AccessPointCommandResult = z.object({
  success: z.boolean(),
  access_point_id: z.string(),
  device_id: z.string().optional(),
  action: z.string(),
  executed_at: z.string(),
  error_message: z.string().nullable().optional(),
  request_id: z.string(),
});

export type AccessPointCommandResultType = z.infer<
  typeof AccessPointCommandResult
>;

export const MAX_COVERAGE_CAMERAS = 10;

export const AssociatedCamera = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  location_id: z.string(),
  health_status: z.string().nullable().optional(),
});

export type AssociatedCameraType = z.infer<typeof AssociatedCamera>;

export const AssociatedCameraList = z.array(AssociatedCamera);
export type AssociatedCameraListType = z.infer<typeof AssociatedCameraList>;
